<template>
	<transition name="fade">
		<p
			v-if="message"
			class="flex items-center gap-1.5 text-[12px] font-medium text-red-500 dark:text-red-400 mt-1.5">
			<svg
				class="w-3.5 h-3.5 flex-shrink-0"
				fill="none"
				stroke="currentColor"
				viewBox="0 0 24 24">
				<path
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="2"
					d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
			</svg>
			{{ message }}
		</p>
	</transition>
</template>

<script>
export default {
	name: "ErrorMessage",
	props: {
		message: { type: String, required: false, default: "" },
	},
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.2s ease;
}
.fade-enter-from,
.fade-leave-to {
	opacity: 0;
}
</style>
